export default __webpack_public_path__ + "static/media/icon_answer_calendar.02f5d98a.svg";